import jQuery from 'jquery';
import LazyEmbed from 'lazyembed2';
import PageLoadedQueue from "./PageLoadedQueue";
import Viewport from "./Viewport";
import Lodash from 'lodash';
import Moment from "moment";
import "moment/locale/de";
import "moment/locale/en-gb";
import OpenSeadragon from 'openseadragon'
import { Dropdown } from "bootstrap";
import * as bootbox from 'bootbox';
import { SwitchToPartner } from './Modules/Orbis/SwitchToPartner';

window.jQuery = window.$ = jQuery;
window.LazyEmbed = LazyEmbed;
window.PageLoadedQueue = PageLoadedQueue;
window.Viewport = new Viewport();
window.viewport = window.Viewport.viewport;
window._ = Lodash;
window.moment = Moment;
window.OpenSeadragon = OpenSeadragon;
window.Dropdown = Dropdown;
window.bootbox = bootbox;

SwitchToPartner();
window.SwitchToPartner = () => {
    SwitchToPartner();
}
